"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const dropdownPortalRoot = document.getElementById(__APP__.PORTAL_ELEMENT_ID);
class Dropdown extends react_1.default.Component {
    dropdownRef = react_1.default.createRef();
    portalElement = document.createElement('div');
    portalRef = react_1.default.createRef();
    dropdownOrigin = {
        top: 0,
        left: 0,
    };
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            dropdownOrigin: mobx_1.observable,
        });
    }
    componentDidMount() {
        if (!dropdownPortalRoot) {
            throw new Error('Missing a portal root element');
        }
        dropdownPortalRoot.appendChild(this.portalElement);
        document.addEventListener('resize', this.updatePosition);
        this.updatePosition();
    }
    componentDidUpdate() {
        this.updatePosition();
    }
    componentWillUnmount() {
        if (!dropdownPortalRoot) {
            throw new Error('Missing a portal root element');
        }
        dropdownPortalRoot.removeChild(this.portalElement);
        document.removeEventListener('resize', this.updatePosition);
    }
    render() {
        const { children, show } = this.props;
        const dropdownPosition = show ? (0, mobx_1.toJS)(this.dropdownOrigin) : {};
        const classes = (0, classnames_1.default)('znd-dropdown', {
            'znd-dropdown--visible': show,
        });
        return (react_1.default.createElement("div", { ref: this.portalRef }, react_dom_1.default.createPortal(react_1.default.createElement("div", { className: classes, style: dropdownPosition, ref: this.dropdownRef }, children), this.portalElement)));
    }
    updatePosition() {
        const ref = this.portalRef.current;
        const { top = 0, left = 0 } = ref?.getBoundingClientRect() ?? {};
        this.dropdownOrigin.top = top;
        this.dropdownOrigin.left = left;
    }
}
__decorate([
    bind_decorator_1.default
], Dropdown.prototype, "updatePosition", null);
exports.default = (0, mobx_react_1.observer)(Dropdown);
